/**
 * Definições visuais dos estágios de entrega do CT-e — espelha a lógica
 * de agregação feita em backend/server.py (_estagio_cte).
 */
import { CheckCircle2, Truck, AlertTriangle, HelpCircle } from "lucide-react";

export const ESTAGIOS_CTE = [
  {
    key: "entregue",
    label: "Entregue",
    bg: "bg-emerald-50",
    text: "text-emerald-700",
    border: "border-emerald-200",
    icon: CheckCircle2,
  },
  {
    key: "em_transito",
    label: "Em trânsito",
    bg: "bg-blue-50",
    text: "text-blue-700",
    border: "border-blue-200",
    icon: Truck,
  },
  {
    key: "problema",
    label: "Problema",
    bg: "bg-rose-50",
    text: "text-rose-700",
    border: "border-rose-200",
    icon: AlertTriangle,
  },
  {
    key: "sem_rastreio",
    label: "Sem rastreio",
    bg: "bg-zinc-100",
    text: "text-zinc-600",
    border: "border-zinc-200",
    icon: HelpCircle,
  },
];

export const getEstagioCte = (key) =>
  ESTAGIOS_CTE.find((e) => e.key === key) || ESTAGIOS_CTE[3];
